<div class="page">
  <div class="page-header">
    <div>
      <h2>Кассы</h2>
      <p>Настройки касс, печатных реквизитов и быстрых действий по смене.</p>
    </div>

    <div class="page-actions">
      <button mat-flat-button color="primary" type="button" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Новая касса
      </button>
    </div>
  </div>

  <div class="page-grid">
    <section class="table-card">
      <div class="loading-shade" *ngIf="loading">
        <mat-spinner diameter="44"></mat-spinner>
      </div>

      <div class="table-scroll">
        <table mat-table [dataSource]="dataSource" class="fiscal-table">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let fiscal" class="id-cell">
            <div>{{ fiscal.id }}</div>
            <div class="cell-muted" *ngIf="isCurrentFiscal(fiscal)">Текущая касса</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="cashbox">
          <th mat-header-cell *matHeaderCellDef>Касса</th>
          <td mat-cell *matCellDef="let fiscal">
            <div class="cell-primary">{{ fiscal.name }}</div>
            <div class="cell-secondary" *ngIf="fiscal.unitDisplayName">{{ fiscal.unitDisplayName }}</div>
            <div class="cell-muted" *ngIf="fiscal.address">{{ fiscal.address }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="seller">
          <th mat-header-cell *matHeaderCellDef>Реквизиты чека</th>
          <td mat-cell *matCellDef="let fiscal">
            <div class="cell-primary">{{ fiscal.sellerDisplayName || 'ФОП не задан' }}</div>
            <div class="cell-secondary">{{ getSellerIdentity(fiscal) }}</div>
            <div class="cell-muted address" *ngIf="fiscal.fullAddress">{{ fiscal.fullAddress }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="mode">
          <th mat-header-cell *matHeaderCellDef>Режим</th>
          <td mat-cell *matCellDef="let fiscal">
            <div class="status-pill" [class.status-test]="fiscal.isTestMode">
              {{ getTypeLabel(fiscal) }}
            </div>
            <div class="cell-secondary">{{ fiscal.isTestMode ? 'Тестовая печать' : 'Боевая печать' }}</div>
            <div class="cell-muted" *ngIf="fiscal.printLogoOnFiscalReceipt">
              Логотип на фискальном чеке включен
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="session">
          <th mat-header-cell *matHeaderCellDef>Сессия</th>
          <td mat-cell *matCellDef="let fiscal">
            <div class="status-pill" [class.status-open]="fiscal.isSessionOpen" [class.status-closed]="!fiscal.isSessionOpen">
              {{ getSessionLabel(fiscal) }}
            </div>
            <div class="cell-secondary" *ngIf="fiscal.prroFiscalNumber">ФН ПРРО: {{ fiscal.prroFiscalNumber }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sum">
          <th mat-header-cell *matHeaderCellDef>Остаток</th>
          <td mat-cell *matCellDef="let fiscal" class="sum-cell">
            {{ supportService.formatMoney(fiscal.sum || 0) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Действия</th>
          <td mat-cell *matCellDef="let fiscal" class="action-cell">
            <div class="action-btn-holder">
              <button mat-icon-button color="primary" title="Настройки кассы" (click)="editFiscal(fiscal, $event)">
                <mat-icon>settings</mat-icon>
              </button>

              <button
                *ngIf="!fiscal.isSessionOpen"
                mat-icon-button
                color="primary"
                title="Открыть сессию"
                (click)="openSession(fiscal, $event)"
              >
                <mat-icon>meeting_room</mat-icon>
              </button>

              <button
                *ngIf="fiscal.isSessionOpen"
                mat-icon-button
                color="warn"
                title="Закрыть сессию"
                (click)="closeSession(fiscal, $event)"
              >
                <mat-icon>door_back</mat-icon>
              </button>

              <button
                mat-icon-button
                color="primary"
                title="X-отчет"
                [disabled]="!fiscal.isSessionOpen"
                (click)="xReport(fiscal.id, $event)"
              >
                <mat-icon>summarize</mat-icon>
              </button>

              <button
                mat-icon-button
                color="primary"
                title="Инкассация"
                [disabled]="!fiscal.isSessionOpen"
                (click)="collection(fiscal.id, $event)"
              >
                <mat-icon>save_alt</mat-icon>
              </button>

              <button mat-icon-button color="warn" title="Удалить кассу" (click)="deleteFiscal(fiscal, $event)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div class="empty-state" *ngIf="!loading && dataSource.filteredData.length === 0">
        Кассы не найдены
      </div>

      <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
    </section>

    <aside class="filters-rail">
      <form class="filters-card" [formGroup]="searchForm">
        <div class="filters-head">
          <h3>Фильтры</h3>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Поиск</mat-label>
          <input
            matInput
            formControlName="query"
            placeholder="Название, ФОП, точка, ИД, адрес, ФН ПРРО"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Тип кассы</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let option of typeOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Сессия</mat-label>
          <mat-select formControlName="session">
            <mat-option *ngFor="let option of sessionOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="search-actions">
          <button mat-flat-button color="primary" type="button" (click)="applyFilters()">
            <mat-icon>search</mat-icon>
            Применить
          </button>
          <button mat-stroked-button type="button" (click)="clearFilters()">
            <mat-icon>filter_alt_off</mat-icon>
            Сбросить
          </button>
        </div>
      </form>
    </aside>
  </div>
</div>
